
.SearchOperator {
  flex-grow: 0 !important;
  width: 140px !important;
}


